import { render, staticRenderFns } from "./edit_large.vue?vue&type=template&id=196b03ee"
import script from "./edit_large.vue?vue&type=script&lang=js"
export * from "./edit_large.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports